import { render, staticRenderFns } from "./MessageCompose.vue?vue&type=template&id=90c05fda"
import script from "./MessageCompose.vue?vue&type=script&lang=js"
export * from "./MessageCompose.vue?vue&type=script&lang=js"
import style0 from "./MessageCompose.vue?vue&type=style&index=0&id=90c05fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports